import { render } from "./SurveyRevisionCard.vue?vue&type=template&id=f9085d54"
import script from "./SurveyRevisionCard.vue?vue&type=script&lang=js"
export * from "./SurveyRevisionCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__